import React from 'react'
import PropTypes from 'prop-types'
import { useCMSEntries } from 'mage-cms'
import Tour from './Tour'
import { withResponsive } from '../Grid'
import NotAvailableOnMobile from './NotAvailableOnMobile'
import { EducationAnalytics } from 'education-tools'

TourPage.propTypes = {
  parameters: PropTypes.shape({
    tourSlug: PropTypes.string
  }),
  isTablet: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired
}

function TourPage({ parameters: { tourSlug }, isMobile, isTablet }) {
  const entries = useCMSEntries({
    contentType: 'UHQMTour',
    filters: { slug: tourSlug },
    include: 2 // Includes items.terms
  })

  if (isMobile || isTablet) {
    return <NotAvailableOnMobile />
  }

  const entry = entries && entries.length > 0 ? entries[0] : null
  const steps = entry ? entry.items : []

  if (!steps || steps.length === 0) {
    return null
  }
  return (
    <>
      <Tour steps={steps} title={entry.title} />
      <EducationAnalytics
        category="uhqm/page/tour"
        action="pageview"
        label={tourSlug}
        referenceType="tour"
        referenceId={entries[0].id}
      />
    </>
  )
}

export default withResponsive(TourPage)
